import BreadcrumbsBlock from '@/blocks/BreadcrumbsBlock';
import FancyHeading from '@/components/FancyHeading';
import IntroText from '@/components/IntroText';
import ListLinks from '@/components/ListLinks';
import { fadeIn, fadeInUp } from '@/constants/motions';
import { pages } from '@/content';
import FullWidthLayout from '@/layouts/FullWidthLayout';
import { PostProvider } from '@/utils/post';
import { motion } from 'framer-motion';
import graphql from '@/lib/graphql';
import mainLayout from '@/graphql/queries/mainLayout';
import jobs from '@/graphql/queries/jobs';
import Markdown from 'react-markdown';
import { REVALIDATE_TIME_IN_SEC } from '@/constants/env';

export default function JobsPage({ jobses, mainLayout, page }) {
  let { contentSection, metaData } = page.attributes;
  return (
    <FullWidthLayout mainLayout={mainLayout} metaData={metaData}>
      <motion.div
        initial="hidden"
        transition={{
          ...fadeIn.transition,
          when: 'beforeChildren',
          staggerChildren: 0.4,
        }}
        variants={fadeIn}
        viewport={fadeIn.viewport}
        whileInView="visible"
      >
        <BreadcrumbsBlock items={[pages.home, pages.careers, pages.jobs]} variants={fadeIn} />
        <section className="my-16 px-4">
          <div className="container-screen">
            <FancyHeading variants={fadeInUp}>{page.attributes.shortName}</FancyHeading>
            <IntroText className="mt-6 max-w-screen-md" variants={fadeInUp}>
              <Markdown>{contentSection[0].content}</Markdown>
            </IntroText>
          </div>
        </section>
        <motion.section className="my-16" variants={fadeInUp}>
          <div className="container-screen">
            <ListLinks items={jobses} />
          </div>
        </motion.section>
      </motion.div>
    </FullWidthLayout>
  );
}

export async function getStaticProps() {
  const jobProvider = new PostProvider('jobs');
  const posts = jobProvider.getAll(['title', 'date', 'slug']);
  // Map fields to what the ListLinks component can render

  const { data: mainLayoutData } = await graphql(mainLayout);
  const { data: pageData } = await graphql(jobs);

  const jobses = pageData.careerPositions.data.map(
    ({ attributes: { title, slug, createdAt } }) => ({
      url: `/careers/jobs/${slug}`,
      textStart: title,
      textEnd: new Date(createdAt).toDateString(),
    })
  );

  return {
    props: {
      jobses,
      mainLayout: mainLayoutData.mainLayout.data,
      page: pageData.page.data,
    },
    revalidate: parseInt(REVALIDATE_TIME_IN_SEC), // In seconds
  };
}
